import { Button } from "react-bootstrap";

const Option = ({ handleOptionSelect, selectedAnswer, option }) => {
  return (
    <>
      <Button
        onClick={() => handleOptionSelect(option)}
        variant="outline-light"
        className={`mb-2 ${selectedAnswer === option ? "active" : ""}`}
        style={{
          backgroundColor:
            selectedAnswer === option ? "#00d8ff" : "transparent",
          borderColor: "#00d8ff",
          color: selectedAnswer === option ? "#000" : "#fff",
          borderRadius: "25px",
        }}
      >
        {option}
      </Button>
    </>
  );
};

export default Option;
